import * as React from "react";
import { useEffect, useState } from "react";
import { Box, Tabs, Tab, List, Divider, Grid2, Alert } from "@mui/material";

import useAsyncEffect from "use-async-effect";
import { useDispatch, useSelector } from "react-redux";

import JobListItem from "./JobListItem";
import { setJobs } from "../redux/jobSlice";
import { JobsAPI } from "../apis/jobsApi";
import JobDetailsDialog from "./JobDetailsDialog";
import JobCompleteDialog from "./JobCompleteDialog";

import constants from "../static/constants.json";
import JobStartDialog from "./JobStartDialog";
import { Check, Warning } from "@mui/icons-material";
import { Link, useNavigate, useParams } from "react-router-dom";
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const AssignmentsView = () => {
  const [tabValue, setTabValue] = useState(0);
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);
  const jobs = useSelector((state: any) => state.jobs.list || []);

  const [filteredJobs, setFilteredJobs] = useState(jobs);

  const [selectedJob, setSelectedJob] = useState({} as any);

  const [activeJobs, setActiveJobs] = useState([] as any);

  const [startingJob, setStartingJob] = useState({} as any);
  const [completingJob, setCompletingJob] = useState({} as any);

  const wildcard = useParams()["*"];
  const navigate = useNavigate();

  useEffect(() => {
    setCorrectJobsToShow();
  }, [jobs, tabValue]); // eslint-disable-line

  useEffect(() => {
    if (wildcard && wildcard !== "") {
      const j = jobs.find((j: any) => j.id === wildcard);
      if (j) {
        setSelectedJob(j);
      }
    }
  }, [wildcard, jobs]);

  const setCorrectJobsToShow = () => {
    const currJobs = jobs.filter(
      (j: any) =>
        j.assigneeId === user.id && j.statusId === constants.jobStatus.started
    );

    setActiveJobs(currJobs);

    // for the tab at the bottom which uses filtered jobs
    switch (tabValue) {
      case 0:
        const upcomingJobs = jobs.filter(
          (j: any) =>
            j.assigneeId === user.id &&
            j.statusId === constants.jobStatus.assigned
          // TODO fix upcoming
        );

        setFilteredJobs(upcomingJobs);
        break;
      case 1:
        console.log("current time is ", new Date().getTime());
        const pastDueJobs = jobs.filter((j: any) => {
          return (
            j.assigneeId === user.id &&
            j.statusId === constants.jobStatus.assigned &&
            new Date(j.endTime).getTime() < new Date().getTime()
          );
        });
        console.log("past due jobs have length", pastDueJobs.length);
        setFilteredJobs(pastDueJobs);
        break;
      case 2:
        const completedJobs = jobs.filter(
          (j: any) =>
            j.assigneeId === user.id &&
            (j.statusId === constants.jobStatus.completed ||
              j.statusId === constants.jobStatus.verification ||
              j.statusId === constants.jobStatus.rejected)
        );
        console.log("user is ", user.id);
        console.log("completed jobs have length", completedJobs.length);
        setFilteredJobs(completedJobs);
        break;

      default:
        break;
    }
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const getJobs = async () => {
    console.log('its here assignments')
    try {
      const js = await JobsAPI.listJobs();
      dispatch(setJobs(js || []));
    } catch(e) {
      navigate("/")
    }
    
  };

  useAsyncEffect(async () => {
    await getJobs();
  }, []);

  const jobsContent = (
    <List
      sx={{
        width: "100%",
        bgcolor: "background.paper",
        border: "1px none red",
      }}
    >
      {filteredJobs.map((j: any, i: number) => (
        <div key={i}>
          <JobListItem
            job={j}
            onSelect={() => {
              navigate(`/assignments/${j.id}`)
              // setSelectedJob(j);
            }}
            onCancel={() => {}}
            onComplete={() => {
              setCompletingJob(j);
            }}
            onStart={() => {
              setStartingJob(j);
            }}
            onDelete={() => {}}
          />
          {i !== jobs.length - 1 ? (
            <Divider variant="inset" component="li" />
          ) : null}
        </div>
      ))}
    </List>
  );

  const tabsContent = (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="basic tabs"
        >
          <Tab label="Upcoming" value={0} {...a11yProps(0)} />
          <Tab label="Past Due" value={1} {...a11yProps(1)} />
          <Tab label="Completed" value={2} {...a11yProps(2)} />
        </Tabs>
      </Box>
    </Box>
  );

  const getNoJobsText = () => {
    switch (tabValue) {
      case 0:
        return (
          <Alert
            icon={<Warning fontSize="inherit" />}
            severity="warning"
            style={{ textAlign: "center", justifyContent: "center" }}
          >
            You have no upcoming jobs. <Link to="/jobs">Click here</Link> to
            search job postings.
          </Alert>
        );
      case 1:
        return (
          <Alert
            icon={<Check fontSize="inherit" />}
            severity="success"
            style={{ textAlign: "center", justifyContent: "center" }}
          >
            There are no overdue jobs assigned to you. Great work!
          </Alert>
        );
      case 2:
        return (
          <Alert
            icon={<Check fontSize="inherit" />}
            severity="success"
            style={{ textAlign: "center", justifyContent: "center" }}
          >
            You have not completed any jobs.
          </Alert>
        );
      default:
        return "";
    }
  };

  const activeJobsContent =
    activeJobs.length > 0 ? (
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={0} onChange={handleTabChange} aria-label="basic tabs">
            <Tab label="Active" value={0} {...a11yProps(0)} />
          </Tabs>
        </Box>
        <List
          sx={{
            width: "100%",
            bgcolor: "background.paper",
            border: "1px none red",
          }}
        >
          {activeJobs.map((j: any, i: number) => (
            <div key={i}>
              <JobListItem
                job={j}
                onSelect={() => {
                  // setSelectedJob(j);
                  
                  navigate(`/assignments/${j.id}`)
                }}
                onCancel={() => {}}
                onComplete={() => {
                  setCompletingJob(j);
                }}
                onStart={() => {
                  setStartingJob(j);
                }}
                onDelete={() => {}}
              />
              {i !== jobs.length - 1 ? (
                <Divider variant="inset" component="li" />
              ) : null}
            </div>
          ))}
        </List>
      </Box>
    ) : null;

  const noJobsContent = <Box>{getNoJobsText()}</Box>;

  return (
    <>
      <JobCompleteDialog
        job={completingJob}
        open={!!completingJob.id}
        handleClose={() => {
          setCompletingJob({});
          setSelectedJob({});
        }}
      />
      <JobStartDialog
        job={startingJob}
        open={!!startingJob.id}
        handleClose={() => setStartingJob({})}
      />
      <JobDetailsDialog
        job={selectedJob}
        open={!!selectedJob.id}
        handleClose={() => {
          setSelectedJob({});
          window.history.back();
        }}
        onComplete={() => setCompletingJob(selectedJob)}
      />
      <Grid2 container sx={{ margin: "1rem" }}>
        <Grid2 size={12} sx={{ display: "flex", justifyContent: "left" }}>
          {activeJobsContent}
        </Grid2>
        <Grid2
          size={12}
          sx={{ display: "flex", justifyContent: "left", paddingTop: "3rem" }}
        >
          {tabsContent}
        </Grid2>

        <Grid2 size={12} sx={{ width: "100%", border: "1px none green" }}>
          {filteredJobs.length > 0 ? jobsContent : noJobsContent}
        </Grid2>
      </Grid2>
    </>
  );
};

export default AssignmentsView;
